import React from "react";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { NavigateFunction, Params } from "react-router-dom";
import {
  DonationPricingPageInputsModel,
  ItemDetailInputModel,
} from "../../../shared/models";
import {
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { CheckOutStore } from "../../../shared/store";
import { AuthService, DonationService } from "../../../shared/services";

interface IProps {
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
  checkoutStore: CheckOutStore;
}

const CheckoutDonation: React.FC<IProps> = ({ params, navigate, checkoutStore }) => {
  console.log(params, navigate);

  function donationId() {
      const id = params.id;
      if (id && UtilityMethods.isValidObjectId(id)) {
          return id;
      }
      return null;
  }

  useEffect(() => {
      if (donationId()) {
          DonationService.getDonation(AuthService.authData.accountId, donationId() || '').subscribe({
              next: (result) => {
                  if (!result.result) {
                      ToastService.showError('Error in loading donation details');
                  } else {
                      const detailSectionData = ItemDetailInputModel.deserializeAPIModel(result.result);
                      const priceData = DonationPricingPageInputsModel.deserializeAPIModel(result.result.price);
                      checkoutStore.updateDonationData(detailSectionData, priceData, true);
                      navigate('/app/checkout/detail');
                  }
              },
              error: () => {
                  ToastService.showError('Error in loading product details');
              },
          });
      }
  }, []);

  return null;
};

export default withRouter(observer(CheckoutDonation));
